import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as DatabaseDownstreamOwnersQuery
export const DatabaseDownstreamOwnerIdsQueryGql: DocumentNode = gql`
query DatabaseDownstreamOwnerIdsQuery($databaseId: ID!, $first: Int!, $offset: Int!) {
  databases(filter: { id: $databaseId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
